import * as net from '~/lib/net';
import { getToken } from '~/apps/shared/services/token';
import * as schemas from 'apps/sender/apis/schemas';
import { defaultTablePageSize } from '~/common/components/consts';
import { PayCodes } from './endpoints';


export async function getPaycodesAttemp(offset: number = 0, limit: number = defaultTablePageSize) {
  const data = await net.apiGet(PayCodes.getPayCodes(offset, limit), getToken());
  return schemas.PaycodeListSchema.load(data);
}

export async function createPaycodeAttemp(locationId: string, dataForm) {
  const payload = schemas.PaycodeAttempRequest.save({...dataForm, locationId});

  const data = await net.apiPost(PayCodes.createPaycodeAttemp(), getToken(), payload);
  return schemas.PaycodeSchema.load(data);
}
